const state = {
  listNotifications: [],
  numberNotification: 0,
  totalNotifications: 0
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/notification/state.js